export default function ({ inverse=false, size=1, className, children, onClick }) {
    return (
        <p 
            className={`cursor-pointer ${!inverse ? 'text-primary-900' : 'text-white'} underline font-bold ${size==1 ? 'text-xl' : 'text-lg'} ${className}`}
            onClick={onClick}
        >
            { children }
        </p>
    )
}